"use strict";

var CLASS_NAME = "GlobalConstantsVariables:",
  V2_APP_PREFIX = "/v2",
  ID_SEPARATOR1 = "-",
  ARRAY_STR_SEPARATOR2 = ".",
  QUERY_PARAM_SEPARATOR = "__",
  JSON_STR_SEPARATOR = "__-__",
  AWS_SERVER_HEADERS = {
    accept: "application/json",
    "x-api-key": "AdPhiUp7P54WsqUGQ0wM49crOApjg3on9sphXezV",
    "Access-Control-Allow-Headers": "Content-Type, Authorization"
  },
  source1 = "realtor.com/realestateandhomes-detail",
  fullAddress = "DEFAULTADDRESSFROM-GlobalConstantsVariables",
  INTEREST_RATE_PRIMARY_RESIDENCE = 3,
  INTEREST_RATE_NOT_PRIMARY_RESIDENCE = 3.5,
  HELP_TOOLTIP_TEXT = {
    monthlyEstmated: "Total Monthly Expense Due",
    mortgageAmount: "Total morgtgage amount due",
    propertyTaxAmount: "Total property tax amount due",
    homeInsuranceAmount: "Total home insurance amount due",
    utilities: "Total utilities due",
    lifeInsurance: "Total life insurance amount due"
  },
  LIFE_INSURANCE_FIELDS = ["birthYear", "age", "gender", "health", "smoker", "height", "weight", "livingsizeSqft", "calculatedCoverage", "termDesired"],
  AGE = "Age (20 - 65)",
  POLICY_TERM = "Policy Term",
  PROPERTY = "Property",
  DATA_RELEASE_VERSION = "v2",
  CLIENT_DATA_CATEGORY = "client_data",
  CLIENT_DATA_CATEGORY_ALL = "client_data_all",
  AGENT_DATA_CATEGORY_ALL = "agent_data_all",
  BACK9_API = "getQuotesFromBack9",
  PACLIFE_NEXT_API = "getQuotesFromPacLifeNext",
  QUOTES_KEY_SEQUENCE_HASH = {
    getQuotesFromBack9: ["state", "face_amounts", "health", "gender", "mode", "birthdate", "smoker", "product_categories"],
    getQuotesFromPacLifeNext: ["solicitationState", "faceAmount", "riskClass", "gender", "premiumFrequency", "dateOfBirth", "productCode", "premiumDuration"]
  },
  PACLIFE_NEXT_API_INPUT = {},
  BACK9_API_INPUT = {};
function getFromCacheV3(e) {
  return get(e);
}
function setInCacheV3(e, t) {
  set(e, t);
}
function getPresets4APIInput(e) {
  var t = {};
  switch (e) {
    case PACLIFE_NEXT_API:
      t = {
        premiumFrequency: "Monthly",
        productCode: "FLEXT65"
      };
  }
  return t;
}
function areAllInputsAvailableFunc(e, t) {
  null == t && (e = "getQuotesFromPacLifeNext", t = {
    premiumFrequency: "Monthly",
    productCode: "FLEXT65",
    solicitationState: "CA",
    faceAmount: 1e6,
    premiumDuration: 27,
    dateOfBirth: "1982-01-01",
    riskClass: "PreferredPlusNonTobacco"
  });
  var r = QUOTES_KEY_SEQUENCE_HASH[e],
    n = Object.keys(t);
  return r.forEach(function (e) {
    if (console.log(":key:", e, "#!sequence.includes(key): ", !r.includes(e)), !n.includes(e)) return console.log("Problem:key:", e), !1;
  }), !0;
}
exports.getAgeLabel = function () {
  return AGE;
}, exports.getPolicyTermLabel = function () {
  return POLICY_TERM;
}, exports.getPropertyLabel = function () {
  return PROPERTY;
}, exports.getDataReleaseVersion = function () {
  return DATA_RELEASE_VERSION;
}, exports.getLifeInsuranceFieldsArray = function () {
  return LIFE_INSURANCE_FIELDS;
}, exports.getInterestRatePrimaryResidence = function () {
  return INTEREST_RATE_PRIMARY_RESIDENCE;
}, exports.getInterestRateNotPrimaryResidence = function () {
  return INTEREST_RATE_NOT_PRIMARY_RESIDENCE;
}, exports.getClientDataCategory = function () {
  return CLIENT_DATA_CATEGORY;
}, exports.getClientDataCategoryAll = function () {
  return CLIENT_DATA_CATEGORY_ALL;
}, exports.getAgentDataCategoryAll = function () {
  return AGENT_DATA_CATEGORY_ALL;
}, exports.getBack9APITag = function () {
  return BACK9_API;
}, exports.getPacLifeNextAPITag = function () {
  return PACLIFE_NEXT_API;
}, exports.getQuotesKeySequence = function (e) {
  return QUOTES_KEY_SEQUENCE_HASH[e];
}, exports.areAllInputsAvailable = function (e, t) {
  return areAllInputsAvailableFunc(e, t);
};